module.exports = __webpack_public_path__ + "img/ryzs7.7e7489a6.jpg";